import React, { useRef } from 'react'
import classNames from 'classnames'

import style from './TmoToggle.module.css'

function TmoToggle({
  isChecked = false,
  onChange,
  disabled,
  className,
  label,
  value,
  size = 'md',
  tabIndex,
  testId
}) {
  const randomString =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  const formId = useRef(randomString)

  const handleChange = ({ target: { checked } }) => {
    onChange(checked)
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onChange(!value)
    }
  }

  return (
    <div
      className={style.container}
      tabIndex={0}
      role='switch'
      aria-checked={isChecked || value}
      onKeyDown={handleKeyDown}
    >
      <label htmlFor={formId.current} className={style.label}>
        {label}
      </label>
      <input
        className={classNames(style.input, className)}
        id={formId.current}
        type='checkbox'
        checked={isChecked || value}
        onChange={handleChange}
        disabled={disabled}
        aria-labelledby={formId.current}
        tabIndex={tabIndex || '0'}
        aria-pressed={isChecked}
        aria-label={label}
        data-testid={testId}
      />
      <label
        className={classNames(style.button, style[size])}
        data-testid={'label-id'}
        htmlFor={formId.current} 
        aria-hidden='true'
        role='presentation'
      />
    </div>
  )
}

export default TmoToggle
